export const isDebug = process.env.WEBPACK_KEEP_CONSOLE_LOGS === 'true'
